(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('PasswordExpirationModalController', PasswordExpirationModalController);

    PasswordExpirationModalController.$inject = ['daysRemaining'];

    function PasswordExpirationModalController(daysRemaining) {
        var vm = this;

        vm.daysRemaining = daysRemaining;
    }
})();